import React, { Component } from 'react';
import ItemsEdit from '../Shared/Items/ItemsBooleanDefault';
import { DownloadButton } from '../../../../utils/download';
import { UploadArea } from '../../../../utils/upload';
import { stepReferSchema } from '@swa_llow/pricing_engine';

class RefersEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            upload: false,
        }
        this.uploadedRefers = this.uploadedRefers.bind(this);
    }

    uploadedRefers(results) {
        const { step } = this.props;
        this.setState({ upload: false });
        this.props.updateStep({
            ...step,
            items: results,
        });
    }

    render() {
        const { 
            selected_item_id,
            step,
            inputs,
            is_approved,
            errors,
        } = this.props;

        const { upload } = this.state;

        const { items = [] } = step;
        const count = items.length;

        return (
            <div>
                <div className="inputs-upload">
                    <div key={`full-buttons`} className="upload-buttons">
                        <button className="button small grey no-hover mr">Count : {count}</button>
                        <DownloadButton 
                            data={{
                                items,
                            }}
                            label={'Refers'}
                            file_name={`${step.key}.csv`}
                            type={'items'}
                            className={'mr'}
                        />
                        {!is_approved && <button className="button small secondary" onClick={() => this.setState({ upload: !this.state.upload })}>
                            <i className="fa fa-angles-up"></i>Upload Refers
                        </button>}
                    </div>
                    {upload &&
                        <div className="exclusions-edit">
                            <UploadArea
                                complete={this.uploadedRefers}
                                type='items' 
                            />
                        </div>
                    }
                </div>
                <ItemsEdit
                    schema={stepReferSchema}
                    set_error={this.props.set_error}
                    updateStep={this.props.updateStep}
                    step={step}
                    inputs={inputs}
                    header={'Refers list'}
                    description={'This section allows you to create a list of quote referral reasons (e.g. refer for an ID check before valid).'}
                    tag={'Refer'}
                    is_approved={is_approved}
                    errors={errors}
                    selected_item_id={selected_item_id}
                />
            </div>
        )
    }
}

export default RefersEdit;